import { regExp } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isNew: Boolean,
    disabled: Boolean
  },

  computed: {
    validation() {
      return regExp.titleOtpSettingsSoft.test(this.proxy.name) &&
        Array.isArray(this.proxy.ipWhitelist) &&
        this.proxy.ipWhitelist.length > 0
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}

